import { useState } from "react";
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";
import { Box, Typography, Paper, Divider } from "@mui/material";

const ExpandableSection = ({ title, content, defaultExpanded = false }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <Paper
      elevation={1}
      className="mb-2 overflow-hidden"
      sx={{
        borderRadius: "8px",
        border: "1px solid #e0e0e0",
      }}
    >
      <Box
        onClick={toggleExpand}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px",
          backgroundColor: "#f5f5f5",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "#eeeeee",
          },
        }}
      >
        <Typography className="font-semibold" sx={{ color: "#333" }}>
          {title}
        </Typography>
        {expanded ? (
          <ExpandLessIcon sx={{ color: "#666" }} />
        ) : (
          <ExpandMoreIcon sx={{ color: "#666" }} />
        )}
      </Box>

      <Divider />

      {expanded && (
        <Box
          sx={{
            padding: "12px",
            backgroundColor: "white",
          }}
        >
          <Typography variant="body2" className="text-gray-700 leading-relaxed">
            {content}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

const ProductInfoExpandable = ({ data }) => {
  console.log("INI DATA DARI EXPANDABLE", data);
  const sections = [
    // {
    //   title: "Deskripsi",
    //   content:
    //     "Informasi lengkap mengenai deskripsi produk atau obat. Deskripsi mencakup penjelasan umum, fungsi, dan tujuan penggunaan.",
    // },
    {
      title: "Komposisi",
      content: data?.composition || "-",
    },
    {
      title: "Dosis",
      content: data?.dosage || "-",
    },
    // {
    //   title: "Aturan Pakai",
    //   content:
    //     "Petunjuk penggunaan yang benar. Cara pakai, waktu yang tepat, dan hal-hal yang perlu diperhatikan selama penggunaan.",
    // },
    // {
    //   title: "Efek Samping",
    //   content:
    //     "Daftar efek samping yang mungkin terjadi. Mulai dari efek samping umum hingga efek samping serius yang memerlukan perhatian medis.",
    // },
    {
      title: "Golongan Obat",
      content: data?.label || "-",
    },
    {
      title: "Nomor Izin Edar",
      content: data?.nie || "-",
    },
    {
      title: "Tanggal Kadaluarsa",
      content: data?.expired_date || "-",
    },
    {
      title: "UOM",
      content: data?.uom || "-",
    },
    {
      title: "Kemasan",
      content: data?.packaging || "-",
    },
  ];

  return (
    <Box className="w-full max-w-3xl mx-auto">
      {sections.map((section, index) => (
        <ExpandableSection
          key={index}
          title={section.title}
          content={section.content}
          defaultExpanded={section.expanded || false}
        />
      ))}
    </Box>
  );
};

export default ProductInfoExpandable;
